import React from 'react';
import TableChartOutlinedIcon from '@mui/icons-material/TableChartOutlined';
import SyncOutlinedIcon from '@mui/icons-material/SyncOutlined';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import HubOutlinedIcon from '@mui/icons-material/HubOutlined';
import PsychologyOutlinedIcon from '@mui/icons-material/PsychologyOutlined';
import TrendingUpOutlinedIcon from '@mui/icons-material/TrendingUpOutlined';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { motion } from 'framer-motion';
import setup from '../assets/data/setup.json';
import MotionSection from './ui/MotionSection';
import SectionHeader from './ui/SectionHeader';

const iconMap: Record<string, React.ReactNode> = {
  spreadsheet: <TableChartOutlinedIcon sx={{ fontSize: 22 }} />,
  repeat: <SyncOutlinedIcon sx={{ fontSize: 22 }} />,
  visibility: <VisibilityOffOutlinedIcon sx={{ fontSize: 22 }} />,
  disconnect: <HubOutlinedIcon sx={{ fontSize: 22 }} />,
  ai: <PsychologyOutlinedIcon sx={{ fontSize: 22 }} />,
  growth: <TrendingUpOutlinedIcon sx={{ fontSize: 22 }} />,
};

function FamiliarProblems() {
  const problems = setup.familiarProblems;

  return (
    <MotionSection id="familiar">
      <SectionHeader
        eyebrow="Sound familiar?"
        title="If any of these sound familiar, I can help."
        subtitle="Business owners don't buy technology—they buy time back, fewer mistakes, and clearer visibility."
      />
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {problems.map((item, index) => (
          <motion.div
            key={item.quote}
            initial={{ opacity: 0, y: 16, filter: 'blur(4px)' }}
            whileInView={{ opacity: 1, y: 0, filter: 'blur(0px)' }}
            viewport={{ once: true }}
            transition={{ duration: 0.45, delay: index * 0.05 }}
            whileHover={{ y: -3 }}
            className="ui-card ui-card-lift p-5 sm:p-6 group"
          >
            <div className="w-11 h-11 rounded-lg border border-line bg-canvas-muted flex items-center justify-center text-ink-secondary mb-4 group-hover:border-accent/30 transition-colors">
              {iconMap[item.icon] ?? iconMap.spreadsheet}
            </div>
            <p className="text-[15px] font-semibold text-ink leading-snug mb-3 tracking-[-0.01em]">
              &ldquo;{item.quote}&rdquo;
            </p>
            <p className="text-sm text-ink-muted leading-relaxed flex items-start gap-2">
              <ArrowForwardIcon
                sx={{ fontSize: 16, marginTop: '2px', flexShrink: 0, color: 'var(--color-accent)' }}
              />
              <span>{item.solution}</span>
            </p>
          </motion.div>
        ))}
      </div>
    </MotionSection>
  );
}

export default FamiliarProblems;
